import {Writable} from 'stream'

export default class InvestigationRecorder {
  constructor (events) {
    events.once('init', this.init.bind(this))
    this.currentRequestId = 0
    this.requests = new Map()
  }

  init (namePrefix, streamingClient) {
    this.investigationRecorderStream = streamingClient.create({
      name: `${namePrefix}immersive-investigation-recorder`,
      path: 'immersive/investigation-recorder'
    })

    const requestResolver = Writable({
      objectMode: true,
      write: ({requestId, error}, enc, next) => {
        const promise = this.requests.get(requestId)
        if (!promise) { return }
        if (error) {
          promise.reject(error)
        } else {
          promise.resolve(true)
        }
        this.requests.delete(requestId)
        next()
      }
    })

    this.investigationRecorderStream.pipe(requestResolver)
  }

  getNextRequestId () {
    this.currentRequestId += 1
    return this.currentRequestId
  }

  startInvestigation (startingPoint) {
    const requestId = this.getNextRequestId()
    const requestWrapper = {requestId, data: {startingPoint, action: 'start'}}
    return new Promise((resolve, reject) => {
      this.requests.set(requestId, {resolve, reject})
      this.investigationRecorderStream.writeData(requestWrapper)
    })
  }
}
